import { emptyLists, type ListsState } from "../domain/lists";

export const LISTS_STORAGE_KEY = "yumnote.lists.v1";
export class ListsRepository {
  constructor(private storage: Pick<Storage, "getItem" | "setItem">) {}
  private snapshot: string | null = null;
  load(): ListsState {
    const raw = this.storage.getItem(LISTS_STORAGE_KEY);
    const state: unknown = raw === null ? emptyLists() : JSON.parse(raw);
    if (!validListsState(state)) throw new Error("Не удалось прочитать списки. Сохранённые данные не изменены.");
    this.snapshot = raw;
    return state;
  }
  save(state: ListsState): void {
    if (!validListsState(state)) throw new Error("Проверьте названия и количество в списке.");
    if (this.storage.getItem(LISTS_STORAGE_KEY) !== this.snapshot) throw new Error("Списки изменились в другой вкладке. Откройте раздел заново перед изменением.");
    const raw = JSON.stringify(state);
    this.storage.setItem(LISTS_STORAGE_KEY, raw);
    this.snapshot = raw;
  }
}
export function validListsState(value: unknown): value is ListsState {
  if (!value || typeof value !== "object") return false;
  const state = value as ListsState;
  if (state.version !== 1 || !Array.isArray(state.documents)) return false;
  const ids = new Set<string>();
  return state.documents.every(doc => {
    if (!doc || (doc.createdAt !== undefined && (typeof doc.createdAt !== "string" || !Number.isFinite(Date.parse(doc.createdAt)))) || (doc.archivedAt !== undefined && typeof doc.archivedAt !== "string") || typeof doc.id !== "string" || ids.has(doc.id) || typeof doc.name !== "string" || !doc.name.trim() || !["list", "template", "dish"].includes(doc.kind) || !["strike", "bottom", "hide"].includes(doc.completed) || typeof doc.grouped !== "boolean" || typeof doc.updatedAt !== "string" || !Array.isArray(doc.items) || !Array.isArray(doc.history)) return false;
    ids.add(doc.id);
    const itemIds = new Set<string>();
    const validItem = (item: typeof doc.items[number]) => item && [item.id, item.name, item.unit, item.note, item.group, item.sourceDish].every(field => typeof field === "string") && !!item.id && !!item.name.trim() && (item.amount === null || (Number.isFinite(item.amount) && item.amount > 0)) && ["needed", "done", "missing"].includes(item.status);
    return doc.items.every(item => { if (!validItem(item) || itemIds.has(item.id)) return false; itemIds.add(item.id); return true; }) && doc.history.every(validItem);
  });
}
